import { createEnumeratorAttrMap, IEnumeratorModel } from "./IEnumeratorModel";

export type INUTSModel = IEnumeratorModel;
export const NUTSModelAttrMap = createEnumeratorAttrMap('NUTS');
